/**
 * 从路径提取文件名称
 * @param path {string} 路径
 * @returns {string}
 */
export function getAssetsName(path) {
  return path ? path.slice(path.lastIndexOf('/') + 1) : '';
}

/**
 * 通过绝对路径获取File对象
 * @param path {string} 路径
 * @returns {object}
 */
export function getFileByPath(path) {
  const name = getAssetsName(path);
  return {
    uid: name,
    name,
    thumbUrl: path,
    status: 'done',
  };
}

//获取时间格式 第二个参数不填则为获取当前时间   yy-MM-dd hh:mm:ss
export function getDate(str, stamp) {
  Date.prototype.Format = function(fmt) {
    var o = {
      'M+': this.getMonth() + 1,
      'd+': this.getDate(),
      'h+': this.getHours(),
      'm+': this.getMinutes(),
      's+': this.getSeconds(),
      S: this.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }
    return fmt;
  };
  return stamp == undefined ? new Date().Format(str) : new Date(stamp).Format(str);
}
